import { useMutation } from "@apollo/client/react";
import GET_CLIENT_INVOICES from "../../queries/invoices/getClientInvoices";
import GET_CLIENTS_WITH_INVOICES from "../../queries/invoices/getClientsWithInvoices";
import { SEND_INVOICE_TO_ASSESSMENT } from "../../mutations/invoices/sendInvoiceToAssessment";
import GET_INVOICE_LATEST_VALIDATION_RESULT from "../../queries/invoices/getInvoiceLatestValidationResult";

export const useSendInvoiceToAssessment = ({
  onCompleted,
  onError,
  noRefetch = false,
}: {
  onCompleted: (result?: any) => void;
  onError: (e?: any) => void;
  noRefetch?: boolean;
}) => {
  const [sendInvoiceToAssessment, { data, loading, error }] = useMutation(
    SEND_INVOICE_TO_ASSESSMENT,
    {
      onCompleted: onCompleted,
      onError: onError,
      refetchQueries: noRefetch
        ? []
        : [
            GET_CLIENT_INVOICES,
            GET_CLIENTS_WITH_INVOICES,
            GET_INVOICE_LATEST_VALIDATION_RESULT,
          ],
      awaitRefetchQueries: true,
    },
  );

  return { sendInvoiceToAssessment, data, loading, error };
};
